const data = JSON.parse(document.querySelector('#customData').textContent);
const projects = data.projects;
const galleries = [...projects, data.examples];
const cards = [...document.querySelectorAll('[data-project-category]')];
const filters = [...document.querySelectorAll('[data-work-filter]')];
const dialog = document.querySelector('#customDialog');
let active = null;
let photo = 0;
const esc = value => String(value).replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));

function filterWork(category) {
  let count = 0;
  cards.forEach(card => {
    card.hidden = category !== 'all' && card.dataset.projectCategory !== category;
    if (!card.hidden) count++;
  });
  filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.workFilter === category)));
  document.querySelector('#customWorkCount').textContent = count + (count === 1 ? ' collaboration' : ' collaborations');
}
filters.forEach(button => button.addEventListener('click', () => filterWork(button.dataset.workFilter)));

function showPhoto() {
  const image = active.images[photo];
  const main = document.querySelector('#customMainImage');
  main.src = image.src;
  main.alt = image.alt;
  main.width = image.width;
  main.height = image.height;
  document.querySelector('#customImageCounter').textContent = (photo + 1) + ' / ' + active.images.length;
  document.querySelector('#previousCustomImage').disabled = active.images.length < 2;
  document.querySelector('#nextCustomImage').disabled = active.images.length < 2;
  document.querySelector('#customThumbs').innerHTML = active.images.map((item, index) =>
    '<button type="button" data-custom-photo="' + index + '" aria-pressed="' + String(index === photo) + '" aria-label="Photograph ' + (index + 1) + '"><img src="' + esc(item.src) + '" alt="" width="48" height="42"></button>'
  ).join('');
}
function openProject(id) {
  const found = galleries.find(project => project.id === id);
  if (!found) return;
  active = found;
  photo = 0;
  document.querySelector('#customDialogTitle').textContent = active.title;
  document.querySelector('#customDialogLocation').textContent = active.location;
  showPhoto();
  dialog.showModal();
}
document.querySelectorAll('[data-open-project]').forEach(button => button.addEventListener('click', () => openProject(button.dataset.openProject)));
document.querySelectorAll('[data-client-project]').forEach(button => button.addEventListener('click', () => openProject(button.dataset.clientProject)));
document.querySelector('#previousCustomImage').addEventListener('click', () => {
  if (!active) return;
  photo = (photo - 1 + active.images.length) % active.images.length;
  showPhoto();
});
document.querySelector('#nextCustomImage').addEventListener('click', () => {
  if (!active) return;
  photo = (photo + 1) % active.images.length;
  showPhoto();
});
document.querySelector('#customThumbs').addEventListener('click', event => {
  const button = event.target.closest('[data-custom-photo]');
  if (!button || !active) return;
  const index = Number(button.dataset.customPhoto);
  if (!Number.isInteger(index) || index < 0 || index >= active.images.length) return;
  photo = index;
  showPhoto();
});
document.querySelector('#closeCustomDialog').addEventListener('click', () => dialog.close());
dialog.addEventListener('click', event => {
  if (event.target !== dialog) return;
  const rectangle = dialog.getBoundingClientRect();
  if (event.clientX < rectangle.left || event.clientX > rectangle.right || event.clientY < rectangle.top || event.clientY > rectangle.bottom) dialog.close();
});
dialog.addEventListener('keydown', event => {
  if (event.key === 'ArrowRight') {
    event.preventDefault();
    document.querySelector('#nextCustomImage').click();
  }
  if (event.key === 'ArrowLeft') {
    event.preventDefault();
    document.querySelector('#previousCustomImage').click();
  }
});
filterWork('all');
